import { useQuery } from '@tanstack/react-query';
import type { JsonValue } from 'type-fest';

import { queryClient, useRequest, type QueryFunction } from '@frontend/api';

import type { AgentConversation } from './types';

type GetConversationParams = {
  uuid: string;
};

export const getUseGetConversationKey = (params: GetConversationParams) => [
  'agents',
  'conversation',
  params.uuid,
];

export const useGetConversation: QueryFunction<
  AgentConversation,
  [GetConversationParams],
  ReturnType<typeof getUseGetConversationKey>
> = (params, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useQuery({
    ...queryOptions,
    queryKey: getUseGetConversationKey(params),
    queryFn: ({ signal }) =>
      request<AgentConversation & JsonValue>(
        `/agents/conversations/${params.uuid}`,
        {
          init: {
            method: 'GET',
            signal,
          },
        },
      ),
  });
};

export const invalidateGetConversationQuery = (
  params: GetConversationParams,
) => {
  queryClient.invalidateQueries({ queryKey: getUseGetConversationKey(params) });
};
